import { LandingHeader } from '../components/landing-header';
import { HeroSection } from '../components/hero-section';
import { PopularTemplates } from '../components/popular-templates';
import { IntegratedWorkflow } from '../components/integrated-workflow';
import { HowItWorks } from '../components/how-it-works';
import { FinalCta } from '../components/final-cta';
import { LandingFooter } from '../components/landing-footer';
import { SeoHead } from '@/components/core';

const homepageJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SELISE Legal Templates',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    logo: typeof window !== 'undefined' ? `${window.location.origin}/logo_512.png` : '/logo_512.png',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@selise.ch',
      contactType: 'customer service',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SELISE Legal Templates',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${typeof window !== 'undefined' ? window.location.origin : ''}/templates?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
];

export const LandingPage = () => (
  <main className="min-h-screen w-full flex flex-col">
    <SeoHead
      title="SELISE Legal Templates — Create Contracts & Agreements in Minutes"
      description="Create compliant contracts and agreements in minutes. SELISE Legal Templates guides you step-by-step with templates verified by real lawyers."
      canonicalPath="/"
      jsonLd={homepageJsonLd}
    />
    <LandingHeader />
    <HeroSection />
    <PopularTemplates />
    <IntegratedWorkflow />
    <HowItWorks />
    <FinalCta />
    <LandingFooter />
  </main>
);
